export const addresses = {
  providerAddress: "0x6a646f6F31A5b5c40e0E2F12c05eE68eD62b43c0",
  dotNounsArt: "0x79707C917079B771E7aCEb96c95B737e7655a3cd",
};
